import React, {useEffect, useState} from "react";
import { connect } from "react-redux";
import { Input, Select, DatePicker, Space } from 'antd';
import FormItem from "components/fields/FormItem";
import TextAreaField from "components/fields/TextAreaField";
import { requiredField } from '../../../../utils/crudSagaHelper';
import { renderLabel,  
	displayFarmNameLocation, selectSearchFilter 
} from '../../../../utils/index';
import { getUserFarmers, getUserFarms } from '../../../../redux/dynamiclist/dynamicListState';
import { DATE_FORMAT } from '../../../../variables/constants';

const BreedingEventFields = ({recordData, mode, form, isAdmin=false, 
	requestingFarmerList, farmerList, doGetUserFarmers, userFarmList, requestingUserFarmList, doGetUserFarms, ...props}) => {

	const [animalTypes, setAnimalTypes] = useState([]);
	const [disableHeadcount, setDisableHeadcount] = useState(false);
	
	const doFilterAnimalTypeOption = (category) =>{
		form.setFieldsValue({type_id: null});
		const filteredTypes = recordData?.animalTypeOptions?.filter((data) => data.category === category);
		setAnimalTypes(filteredTypes);		
	}

	useEffect(() => {
		if(recordData){
			setDisableHeadcount(recordData.id > 0);
			doFilterAnimalTypeOption(recordData.category_id);
			
			if(isAdmin){
				if(recordData.user_details_id){
					doGetUserFarmers({user_details_id:recordData.user_details_id, asOptions: 1, user_type: 3});
					doGetUserFarms({user_details_id:recordData.user_details_id, asOptions: 1});
				}
			}			
		}
	}, [recordData]);

  	return (
    	<>
			<FormItem name="id" hidden>
				<Input type="hidden"/>
			</FormItem>

			<div className="form-column-4">
				<FormItem 
					name="mating_date"
					label="Mating Date"
					rules={[requiredField()]}
				>
					{mode === 'edit' ?
					<DatePicker id="mating_date"
						format={DATE_FORMAT}
					/>					
					: renderLabel(recordData?.mating_date)
					}                
				</FormItem>
				
				<FormItem 
					name="sire_id"
					label="Sire ID"
					rules={[requiredField()]}
				>
					{mode === 'edit' ?
					<Select id="sire_id"
						allowClear={true}
						showSearch
						options={recordData?.sireOptions}
						filterOption={(input, option) => selectSearchFilter(input, option)}
					/>					
					: renderLabel(recordData?.sire_id)
					}                
				</FormItem>

				<FormItem 
					name="dam_id"
					label="Dam ID"
					rules={[requiredField()]}
				>
					{mode === 'edit' ?
					<Select id="dam_id"
						allowClear={true}
						showSearch
						options={recordData?.damOptions}
						filterOption={(input, option) => selectSearchFilter(input, option)}
					/>							
					: renderLabel(recordData?.dam_id)
					}                
				</FormItem>

				<FormItem extra="col-span-1 md:col-span-2"
					name="farm_id"
					label="Farm Location"
					rules={[requiredField()]}
				>
					{mode === 'edit' ?
					<Select id="farm_id"
						allowClear={true}
						showSearch
						options={recordData?.farmLocations}
						filterOption={(input, option) => selectSearchFilter(input, option)}
					/>	
					: renderLabel(displayFarmNameLocation(recordData?.farm))
					}					
				</FormItem>
				
				<FormItem extra="col-span-1 md:col-span-3 xl:col-span-4"
					name="remarks"
					label="Notes or Remarks"
				>
					{mode === 'edit' ?
					<TextAreaField id="remarks"
						maxLength={1000}
					/>	
					: renderLabel(recordData?.remarks)
					}					
				</FormItem>
			</div>
	 	</>
  	);
};

const mapStateToProps = (state) => ({
	farmerList: state.dynamicList.userFarmers?.items,
	requestingFarmerList: state.dynamicList.userFarmers?.requesting,
	userFarmList: state.dynamicList.userFarms?.items,
	requestingUserFarmList: state.dynamicList.userFarms?.requesting,
});

const mapDispatchToProps = (dispatch) => ({
	doGetUserFarmers: (filters) => dispatch(getUserFarmers(filters)),
	doGetUserFarms: (filters) => dispatch(getUserFarms(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BreedingEventFields);
